import { observable } from "mobx"

export const param = observable.map<string, any>();
const paramStore = {
    setParam: (key: string, value: any) => {
        param.set(key, value);
    },

    getParam: (key: string) => {
        return param.get(key);
    },

    deleteParam(key: string) {
        return param.delete(key);
    }
}

export default paramStore;